(jQuery(document).ready(function () {
  (
    // $("#custom-loader").addClass("custom-loaderhide"),
    // document.getElementById("custom-loader").setAttribute("style", "display: flex !important;"),
    jQuery("body").on("click", "#toptoBottom", function () {
      return (
        "function" == typeof jQuery.easing.easeInOutQuad
          ? jQuery("html, body").animate({ scrollTop: 0 }, 100, "easeInOutQuad")
          : jQuery("html, body").animate({ scrollTop: 0 }, 100, "swing"),
        !1
      );
    }));
  let e = document.getElementById("toptoBottom");
  ((e.style.display = "none"),
    (window.onscroll = function () {
      document.body.scrollTop > 20 || document.documentElement.scrollTop > 20
        ? (e.style.display = "block")
        : (e.style.display = "none");
    }),
    $("#Search-In-Modal").on("keypress", function () {
      $('label[for="Search-In-Modal"]').addClass("field__label").text("");
    }),
    $(".search-modal__close-button").on("click", function () {
      $('label[for="Search-In-Modal"]').addClass("field__label").text("");
    }),
    $("#Search-In-Modal").on("input", function () {
      $(this).val().length > 0
        ? $('label[for="Search-In-Modal"]').text("")
        : $('label[for="Search-In-Modal"]').text("What are you looking for?");
    }),
    setTimeout(function () {
      (jQuery(".footer-block__heading").eq(1).addClass("rotation-cls"),
        jQuery("#collapse1").addClass("show"),
        $('label[for="Search-In-Modal"]')
          .addClass("field__label")
          .text("What are you looking for?"));
    }, 1e3),
    // setTimeout(function () {
    //   document
    //     .getElementById("custom-loader")
    //     .setAttribute("style", "display: none !important;");
    // }, 500),
    document.addEventListener("click", function (e) {
      e.target.closest(".jdgm-write-rev-link") &&
        document.body.classList.add("jdgm-review-open-overlay-cls");
    }),
    document.addEventListener("click", function (e) {
      e.target.closest(".jdgm-write-review-modal__close-btn") &&
        document.body.classList.remove("jdgm-review-open-overlay-cls");
    }),
    document.addEventListener("click", function (e) {
      e.target.closest(".openModalBtn,.edit-btn") &&
        document.body.classList.add("jdgm-review-open-overlay-cls");
    }),
    document.addEventListener("click", function (e) {
      e.target.closest(".icon-close") &&
        document.body.classList.remove("jdgm-review-open-overlay-cls");
    }),
    document.addEventListener("click", function (e) {
      e.target.closest(".jdgm-write-review-modal__nav-btn-close") &&
        document.body.classList.remove("jdgm-review-open-overlay-cls");
    }));
  const t = document.getElementById("Search-In-Modal"),
    n = t?.closest("form");
  (n &&
    t &&
    n.addEventListener("submit", function (e) {
      const o = n.action + "?q=" + encodeURIComponent(t.value);
      new TextEncoder().encode(o).length > 350 &&
        (e.preventDefault(),
        alert(
          "Your search is too long and cannot be processed. Please shorten it.",
        ));
    }),
    document.addEventListener("click", function (e) {
      const t = e.target.closest(
        "#predictive-search-option-search-keywords button",
      );
      if (!t) return;
      const n = t.querySelector("[data-predictive-search-search-for-text]");
      if (!n) return;
      const o = n.textContent.match(/Search for “(.+)”/),
        i = o ? o[1] : "",
        a = `/search?q=${encodeURIComponent(i)}`;
      new TextEncoder().encode(a).length > 350 &&
        (e.preventDefault(),
        e.stopPropagation(),
        alert("Your search query is too long. Please shorten it."));
    }),
    t.closest("form").addEventListener("submit", function (e) {
      t.value.trim();
    }),
    t.addEventListener("keyup", function (e) {
      if (t.value.trim());
      else {
        const e = document.getElementById("predictive-search-results");
        e && (e.innerHTML = "");
      }
    }),
    jQuery(".shopify-payment-button__button--unbranded") &&
      jQuery(".shopify-payment-button__button--unbranded").html("Buy Now"),
    jQuery(".jdgm-rev-widg__summary-stars").each(function () {
      const e = jQuery(this);
      setTimeout(function () {
        const t = jQuery("#judgeme_product_reviews .jdgm-rev-widg");
        if (!t.length) return;
        const n = Number(t.data("number-of-reviews")),
          o = Number(t.data("average-rating")).toFixed(1);
        n > 0
          ? e
              .find(".jdgm-rev-widg__summary-average")
              .html(`${o}`)
          : e.find(".noreview-cls").length ||
            e.append('<span class="noreview-cls">0 Reviews</span>');
      }, 500);
    }),
    jQuery(document).on("jdgm.doneRendering", function () {
      const e = jQuery("#judgeme_product_reviews .jdgm-rev-widg");
      if (!e.length) return;
      const t = e.data("number-of-reviews"),
        n = e.data("average-rating");
      jQuery(".jdgm-rev-widg__summary-text").html(
        `${n} out of 5 (${t} Reviews)`,
      );
    }),
    $(document).on(
      "click",
      ".jdgm-write-review-modal__nav-btn-next,.jdgm-write-review-modal__stars",
      function () {
        $(".jdgm-write-review-modal__close-btn").css({
          opacity: "1",
          display: "block",
        });
      },
    ),
    $(document).on("click", ".jdgm-star", function () {
      setTimeout(function () {
        $(".jdgm-write-review-modal__close-btn").css({
          opacity: "1",
          display: "block",
        });
      }, 50);
    }),
    $(document).on("click", ".jdgm-widget-actions-wrapper", function () {
      ($(".jdgm-write-review-modal__close-btn").css({
        opacity: "1",
        display: "block",
      }),
        $(".jdgm-write-review-modal__sections").css("transform", ""));
    }),
    $(document).on("click", ".facets__summary-label", function () {
      $(".facets__summary-label").toggleClass("availible-label-rotation");
    }),
    $(document).on("change", "#SortBy", function () {
      $(this).val()
        ? localStorage.setItem("sortBySelected", "true")
        : localStorage.removeItem("sortBySelected");
    }),
    document.addEventListener("shopify:section:render", function () {
      "true" === localStorage.getItem("sortBySelected") &&
        $("#SortBy").addClass("selected-option");
    }));
  (document.querySelectorAll(".quantity__input").forEach((e) => {
    e.addEventListener("keydown", function (e) {
      e.preventDefault();
    });
  }),
    jQuery("#AddressPhoneNew").on("keyup", function () {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    }),
    jQuery("#RegisterForm-FirstName").on("keyup", function () {
      this.value = this.value.replace(/[^a-zA-Z \.]/g, "");
    }),
    jQuery("#RegisterForm-LastName").on("keyup", function () {
      this.value = this.value.replace(/[^a-zA-Z \.]/g, "");
    }),
    jQuery("#AddressPhone_edit").on("keyup", function () {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    }),
    jQuery("#AddressZip_edit").on("keyup", function () {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    }),
    jQuery("#AddressZipNew").on("keyup", function () {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    }),
    jQuery("#smlPhoneNumberInput").on("keyup", function () {
      this.value = this.value.replace(/[^0-9\.]/g, "");
    }),
    jQuery("#AddressPhoneNew").keydown(function (e) {
      if (((k = e.which), 10 == jQuery(this).val().length))
        return 8 == k || (e.preventDefault(), !1);
    }),
    jQuery("#AddressZipNew").keydown(function (e) {
      if (((k = e.which), 6 == jQuery(this).val().length))
        return 8 == k || (e.preventDefault(), !1);
    }),
    jQuery("#AddressZip_edit").keydown(function (e) {
      if (((k = e.which), 6 == jQuery(this).val().length))
        return 8 == k || (e.preventDefault(), !1);
    }),
    jQuery("#AddressPhone_edit").keydown(function (e) {
      if (((k = e.which), 10 == jQuery(this).val().length))
        return 8 == k || (e.preventDefault(), !1);
    }),
    jQuery("#smlPhoneNumberInput").keydown(function (e) {
      if (((k = e.which), 10 == jQuery(this).val().length))
        return 8 == k || (e.preventDefault(), !1);
    }));
  var o = new Swiper(".bannerSwiper", {
    spaceBetween: 30,
    centeredSlides: !0,
    loop: true,
    autoplay: false,
    // autoplay: { delay: 5000, disableOnInteraction: !1 },
    pagination: { el: ".swiper-pagination", clickable: !0 },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  (new Swiper(".shopBycategory", {
    spaceBetween: 20,
    pagination: { el: ".swiper-pagination", clickable: !0 },
    breakpoints: {
      640: { slidesPerView: 1.5, spaceBetween: 20, pagination: !1 },
      768: { slidesPerView: 1.5, spaceBetween: 20, pagination: !1 },
      1024: { slidesPerView: 4, spaceBetween: 50, pagination: !1 },
    },
  }),
    new Swiper(".productSwiper", {
      spaceBetween: 20,
      loop: !0,
      autoplay: !1,
      navigation: { nextEl: ".custom-next-btn", prevEl: ".custom-prev-btn" },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 15, pagination: !1 },
        640: { slidesPerView: 2.5, spaceBetween: 15 },
        767: { slidesPerView: 2.5, spaceBetween: 15, pagination: !1 },
        1024: { slidesPerView: 3, spaceBetween: 10, pagination: !1 },
        1366: { slidesPerView: 4, spaceBetween: 10, pagination: !1 },
        1600: { slidesPerView: 5, spaceBetween: 15, pagination: !1 },
      },
    }),
    new Swiper(".relatedproductSwiper", {
      spaceBetween: 20,
      loop: !0,
      autoplay: !1,
      navigation: {
        nextEl: ".related-button-next",
        prevEl: ".related-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 15, pagination: !1 },
        640: { slidesPerView: 2.5, spaceBetween: 15 },
        767: { slidesPerView: 2.5, spaceBetween: 15, pagination: !1 },
        1024: { slidesPerView: 3, spaceBetween: 10, pagination: !1 },
        1366: { slidesPerView: 4, spaceBetween: 10, pagination: !1 },
        1600: { slidesPerView: 5, spaceBetween: 15, pagination: !1 },
      },
    }),
     new Swiper(".bunddlerelatedproductSwiper", {
      spaceBetween: 20,
      loop: !0,
      autoplay: !1,
      navigation: {
        nextEl: ".related-button-next",
        prevEl: ".related-button-prev",
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 15, pagination: !1 },
        640: { slidesPerView: 2.5, spaceBetween: 15 },
        767: { slidesPerView: 2.5, spaceBetween: 15, pagination: !1 },
        1024: { slidesPerView: 3, spaceBetween: 10, pagination: !1 },
        1366: { slidesPerView: 4, spaceBetween: 10, pagination: !1 },
        1600: { slidesPerView: 5, spaceBetween: 15, pagination: !1 },
      },
    }),
    new Swiper(".cartproductSwiper", {
      spaceBetween: 20,
      loop: !0,
      autoplay: !1,
      navigation: {
        nextEl: ".cartcustom-next-btn",
        prevEl: ".cartcustom-prev-btn",
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 15, pagination: !1 },
        640: { slidesPerView: 2.5, spaceBetween: 15 },
        767: { slidesPerView: 2.5, spaceBetween: 15, pagination: !1 },
        1024: { slidesPerView: 3, spaceBetween: 10, pagination: !1 },
        1366: { slidesPerView: 4, spaceBetween: 10, pagination: !1 },
        1600: { slidesPerView: 5, spaceBetween: 15, pagination: !1 },
      },
    }),
    new Swiper(".featureSwiper", {
      spaceBetween: 20,
      loop: !0,
      autoplay: !1,
      navigation: {
        nextEl: ".featured-next-btn",
        prevEl: ".featured-prev-btn",
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 15, pagination: !1 },
        640: { slidesPerView: 2.5, spaceBetween: 15 },
        767: { slidesPerView: 2.5, spaceBetween: 15, pagination: !1 },
        1024: { slidesPerView: 3, spaceBetween: 10, pagination: !1 },
        1366: { slidesPerView: 4, spaceBetween: 10, pagination: !1 },
        1600: { slidesPerView: 5, spaceBetween: 15, pagination: !1 },
      },
    }),
    new Swiper(".brandVideo", { pagination: { el: ".swiper-pagination" } }),
    new Swiper(".socialBar", {
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: !0,
        clickable: !0,
      },
      breakpoints: {
        0: { slidesPerView: 1.2, spaceBetween: 15, centeredSlides: !0 },
        744: { slidesPerView: 2.5, spaceBetween: 15 },
        767: { slidesPerView: 3, spaceBetween: 15 },
        1024: { slidesPerView: 3, spaceBetween: 20 },
        1400: { slidesPerView: 3, spaceBetween: 15 },
        2e3: { slidesPerView: 4, spaceBetween: 20 },
      },
    }),
    new Swiper(".testimonialSlider", {
      spaceBetween: 20,
      autoplay: !1,
      loop: !0,
      pagination: { el: ".swiper-pagination", clickable: !0 },
      navigation: {
        nextEl: ".testimonials-next-btn",
        prevEl: ".testimonials-prev-btn",
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 15, pagination: !1 },
        767: { slidesPerView: 1.6, spaceBetween: 15, pagination: !1 },
        1024: { slidesPerView: 2, spaceBetween: 10, pagination: !1 },
        1400: { slidesPerView: 3, spaceBetween: 20, pagination: !1 },
      },
    }),
    (o = new Swiper(".prd-details-gallery", {
      loop: !0,
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: !0,
      watchSlidesProgress: !0,
    })),
    new Swiper(".prd-details-gallery2", {
      loop: !0,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: { swiper: o },
    }));
  (setTimeout(function () {
    $(".footer-block")
      .first()
      .find(".footer-block__heading")
      .addClass("rotation-cls");
  }, 500),
    setTimeout(function () {
      var e = $("#judgeme_product_reviews");
      e.length && e.wrap('<div class="cust-rating"></div>');
    }, 2e3),
    document.addEventListener("click", function (e) {
      const t = e.target.closest(".footer-block__heading");
      if (!t) return;
      if (
        (e.preventDefault(),
        e.stopImmediatePropagation(),
        window.innerWidth > 768)
      )
        return;
      const n = t
          .closest(".footer-block")
          .querySelector(".footer-block__details-content"),
        o = t.classList.contains("rotation-cls");
      (document
        .querySelectorAll(".footer-block__heading")
        .forEach((e) => e.classList.remove("rotation-cls")),
        document
          .querySelectorAll(".footer-block__details-content")
          .forEach((e) => {
            (e.classList.remove("active"), (e.style.display = "none"));
          }),
        o ||
          (t.classList.add("rotation-cls"),
          n.classList.add("active"),
          (n.style.display = "block")));
    }),
    $("#footer-em-link").on("click", function (e) {
      (e.preventDefault(),
        window.open("https://www.everymedia.world/", "_blank"));
    }),
   
  );
  const i = document.querySelectorAll(".accordion details");
  (i.forEach((e) => {
    e.addEventListener("toggle", function () {
      this.open &&
        i.forEach((e) => {
          e !== this && (e.open = !1);
        });
    });
  }),
    $(".accordion-button").on("click", function () {
      ($(".accordion-button").removeClass("active"),
        $(this).hasClass("collapsed") || $(this).addClass("active"));
    }),
    $(".accordion-collapse.show")
      .prev()
      .find(".accordion-button")
      .addClass("active"),
    $(window).on("scroll", function () {
      $(this).scrollTop() > 0
        ? $(".homepage").addClass("is-sticky")
        : $(".homepage").removeClass("is-sticky");
    }),
    jQuery("#judgeme_product_reviews").appendTo(".cust-reviwe-container"));
}),
  );


  const announcementSlider = new Swiper('.announcementSwiper', {
  direction: 'vertical',
  loop:true,
  speed: 1200,

  autoplay:{
    disableOnInteraction:false
  },

  navigation:{
    nextEl:'.announcement-arrow.next',
    prevEl:'.announcement-arrow.prev'
  }

});

  var clientNewSlider = new Swiper(".clientSlider", {
  slidesPerView: 5,
  spaceBetween: 0,
  loop: true, // required for smooth autoplay

  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },

  breakpoints: {
    0: {
      slidesPerView: 4,
      // centeredSlides: true
       
      
    },
    768: {
      slidesPerView: 5,
      autoplay: false, // ❗ desktop auto slide OFF (if you want ON, change to same config)
      allowTouchMove: false
    }
  }
});

  var socialPlatformsSlider = new Swiper(".socialPlatformsSlider", {
  slidesPerView: 3,
  spaceBetween: 0,
  loop: true, // required for smooth autoplay

  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },

  breakpoints: {
    0: {
      slidesPerView: 3,
      // centeredSlides: true
       
      
    },
    480: {
      slidesPerView: 3,
      autoplay: false, // ❗ desktop auto slide OFF (if you want ON, change to same config)
      allowTouchMove: false
    }
  }
});



let mm = gsap.matchMedia();
function waitForMenuAndSetActive() {
  var e = document.querySelector("ul.gm-menu");
  e && 0 !== e.querySelectorAll("a.gm-target").length
    ? (setActiveMenu(),
      new MutationObserver(setActiveMenu).observe(e, {
        childList: !0,
        subtree: !0,
      }))
    : setTimeout(waitForMenuAndSetActive, 100);
}
function setActiveMenu() {
  var e = window.location.pathname.replace(/\/$/, "");
  (document.querySelectorAll(".gm-item.active").forEach(function (e) {
    e.classList.remove("active");
  }),
    document.querySelectorAll("a.gm-target").forEach(function (t) {
      var n = t.getAttribute("href");
      if (n && "#" !== n && !n.startsWith("javascript")) {
        var o = new URL(t.href, window.location.origin).pathname.replace(
            /\/$/,
            "",
          ),
          i = t.closest("li");
        if (e === o) {
          i && i.classList.add("active");
          var a = i.closest(".gm-level-0");
          a && a.classList.add("active");
        }
        if ("/collections/shop" === o && e.startsWith("/collections")) {
          var r = t.closest("li.gm-level-0");
          r && r.classList.add("active");
        }
      }
    }));
}
(mm.add("(min-width: 1280px)", () => {
  (gsap.to(".leaf-1", {
    y: "0px",
    ease: "power1.out",
    scrollTrigger: {
      trigger: ".leaf-1",
      start: "top 80%",
      end: "bottom 60%",
      scrub: 1.5,
    },
  }),
    gsap.to(".leaf-2", {
      y: "70px",
      x: "40px",
      scrollTrigger: {
        trigger: ".leaf-2",
        scrub: 1,
        start: "top 70%",
        end: "bottom 70%",
        duration: 2,
      },
    }));
}),
  mm.add("(max-width: 991px)", () => {
    (gsap.to(".leaf-1", {
      y: "0px",
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".leaf-1",
        scrub: 1.5,
        start: "top 90%",
        end: "bottom 70%",
      },
    }),
      gsap.to(".leaf-2", {
        y: "20px",
        x: "30px",
        scrollTrigger: {
          trigger: ".leaf-2",
          scrub: 1,
          start: "top 80%",
          end: "bottom 60%",
          duration: 2,
        },
      }));
  }),
  document.addEventListener("DOMContentLoaded", () => {
    const e = document.querySelectorAll(".fade-element"),
      t = new IntersectionObserver(
        (e, t) => {
          e.forEach((e) => {
            e.isIntersecting && e.target.classList.add("visible");
          });
        },
        { threshold: 0 },
      );
    (e.forEach((e) => {
      t.observe(e);
    }),
      setInterval(() => {
        const e = document.querySelector(".jdgm-write-rev-link");
        e && (e.textContent = "Write a Review");
      }, 300));
  }),
  $(".header__icon--search").on("click", function () {
    $("body").addClass("search-active");
  }),
  $("#showRecovery").on("click", function () {
    ($("#login").css({ transform: "translateY(30px)", opacity: "0" }),
      setTimeout(() => {
        ($("#login").attr("hidden", !0),
          $("#recover")
            .removeAttr("hidden")
            .css({ transform: "translateY(0px)", opacity: "1" }));
      }, 300));
  }),
  $("#showLogin").on("click", function () {
    ($("#recovery").css({ transform: "translateY(30px)", opacity: "0" }),
      setTimeout(() => {
        ($("#recover").attr("hidden", !0),
          $("#login")
            .removeAttr("hidden")
            .css({ transform: "translateY(0px)", opacity: "1" }));
      }, 300));
  }),
  document.addEventListener("DOMContentLoaded", function () {
    "#recover" === window.location.hash &&
      ((document.getElementById("recover").style.display = "block"),
      (document.getElementById("login").style.display = "none"),
      $("#login").attr("hidden", !0),
      $("#recover")
        .removeAttr("hidden")
        .css({ transform: "translateY(0px)", opacity: "1" }));
  }),
  document.addEventListener("DOMContentLoaded", waitForMenuAndSetActive),
  setActiveMenu());
var menuContainer = document.querySelector("ul.gm-menu");
if (menuContainer) {
  var observer = new MutationObserver(setActiveMenu);
  observer.observe(menuContainer, { childList: !0, subtree: !0 });
}
($(function () {
  $(".about-us").length && $("body").addClass("abt-us-page");
}),
  document.querySelectorAll("img").forEach((e) => e.removeAttribute("title")),
  jQuery(function (e) {
    e("a").removeAttr("title");
    new MutationObserver(() => {
      e("a").removeAttr("title");
    }).observe(document.body, { childList: !0, subtree: !0 });
  }),
  document.addEventListener("DOMContentLoaded", function () {
    const e = document.querySelector(".product-details");
    e &&
      e.addEventListener("wheel", (e) => {
        e.stopPropagation();
      });
  }),
  document.addEventListener("DOMContentLoaded", function () {
    const e = document.querySelector("#shopBannerCarousel"),
      t = bootstrap.Carousel.getOrCreateInstance(e);
    let n = 0,
      o = 0,
      i = !1,
      a = !1;
    (e.addEventListener("mousedown", (e) => {
      ((i = !0), (a = !1), (n = e.pageX), (o = e.pageY));
    }),
      e.addEventListener("mousemove", (e) => {
        if (!i) return;
        const t = e.pageX - n,
          r = e.pageY - o;
        Math.abs(t) > Math.abs(r) && ((a = !0), e.preventDefault());
      }),
      e.addEventListener("mouseup", (e) => {
        if (!i || !a) return void (i = !1);
        const o = e.pageX - n;
        (o > 50 ? t.prev() : o < -50 && t.next(), (i = !1));
      }),
      e.addEventListener("mouseleave", () => {
        i = !1;
      }),
      e.addEventListener(
        "touchstart",
        (e) => {
          ((n = e.touches[0].clientX), (o = e.touches[0].clientY), (a = !1));
        },
        { passive: !0 },
      ),
      e.addEventListener(
        "touchmove",
        (e) => {
          const t = e.touches[0].clientX - n,
            i = e.touches[0].clientY - o;
          Math.abs(t) > Math.abs(i) && ((a = !0), e.preventDefault());
        },
        { passive: !1 },
      ),
      e.addEventListener("touchend", (e) => {
        if (!a) return;
        const o = e.changedTouches[0].clientX - n;
        o > 50 ? t.prev() : o < -50 && t.next();
      }),
      new bootstrap.Carousel(e, {
        interval: 5e3,
        ride: "carousel",
        touch: !1,
        pause: !1,
      }));
  }));

const dropdowns = document.querySelectorAll(".menu-drawer__navigation details");

  dropdowns.forEach((dropdown) => {

    dropdown.querySelector("summary").addEventListener("click", function (e) {

      const isOpen = dropdown.hasAttribute("open");

      dropdowns.forEach((item) => {
        item.removeAttribute("open");
      });

      if (!isOpen) {
        dropdown.setAttribute("open", "true");
      }

      e.preventDefault();
    });

  });




